// Query for danh sách xác minh khủng bố (tcustomer where terrorism_user_approval IS NOT NULL)
export const GET_TERRORIST_VERIFICATION_LIST = `
  query GetTerroristVerificationList($input: TcustomerWhereInput!, $skip: Float, $take: Float) {
    getCustomer(where: $input, skip: $skip, take: $take, orderBy: { terrorismUserDate: DESC }) {
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemsPerPage
        totalItems
        totalPages
      }
      items {
        id
        sapCustomerId
        storeName
        name
        plantId
        terrorismType
        terrorismUserApproval
        terrorismUserDate
        terrorismUserPlant
        tterrorismUserApproval {
          id
          fullName
        }
        terrorismManagerApproval
        terrorismManagerDate
        tterrorismManagerApproval {
          id
          fullName
        }
        address
        tcity {
          name
        }
        tdistrict {
          name
        }
        tward {
          name
        }
      }
    }
  }
`;

// Mutation cập nhật terrorism_manager_approval (phê duyệt bởi quản lý)
export const UPDATE_CUSTOMER_TERRORISM = `
  mutation UpdateCustomerTerrorism($input: TcustomerInput!) {
    updateCustomer(input: $input) {
      id
      terrorismManagerApproval
      terrorismManagerDate
    }
  }
`;
